// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jJI_yWlLMcfma6 {
  position: relative;
  width: 100%;
  max-width: 850px;
  margin: 0 auto;
  padding: 32px;
}
.IjZtB5YDYMmlgC {
  position: relative;
  margin-bottom: 24px;
}
._XoDMnu5DHxUqm {
  position: relative;
  margin: 0 0 4px 40px;
  padding: 8px 0;
}
.AwfDAU7gg3zp9n {
  position: absolute;
  top: 5px;
  left: -35px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activityContainer": `jJI_yWlLMcfma6`,
	"windowModule": `IjZtB5YDYMmlgC`,
	"windowModuleTitle": `_XoDMnu5DHxUqm`,
	"windowModuleTitleIcon": `AwfDAU7gg3zp9n`
};
export default ___CSS_LOADER_EXPORT___;
